module.exports = __webpack_public_path__ + "static/circe-bold-65-208f1642b4f4c1bd8b66d7c7f56b5579.otf";